module.exports = __webpack_public_path__ + "img/001-sight.0d9ed9b6.svg";